<template>
	<div class="print">
		<div class="right-wrap">
			<div class="search" @keyup.enter="query">
				<div class="qjc-flex">
					<div class="search_title">優惠碼：</div>
					<el-input v-model="disc" placeholder="請輸入優惠碼" class="qjc-fts-14">
					</el-input>
				</div>
				<el-button @click="query" :loading="submiting" class="nextBtn">搜索</el-button>
				<el-button @click="handleReset" :loading="submiting" class="nextBtn">重置</el-button>

				<el-button class="nextBtn" @click="showDialog('add')">添加優惠碼</el-button>
				<el-button class="nextBtn" @click="showDialog2('add')">批量添加優惠碼</el-button>
				<button v-show="downFile" type="submit" class="nextBtn" @click="isAlert3 = true">批量導出</button>
			</div>

			<el-table :header-cell-style="{background:'#f0f3f8',color:'#333'}" :data="list" border style="width: 100%">
				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-download.png')"></el-image>
						<div class="empty-text">暫無數據</div>
					</div>
				</template>
				<el-table-column prop="id" label="編號" class-name="id" width="60">
					<template slot-scope="scope">
						{{ scope.row.id  ? scope.row.id :'--' }}
					</template>
				</el-table-column>
				<el-table-column prop="cid" label="分類" class-name="cid">
					<template slot-scope="scope">
						<div class="">{{scope.row.cid == '1' ? '优惠码' : '礼品卡'}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="code" label="優惠碼" class-name="code">
					<template slot-scope="scope">
						<div class="" v-if="scope.row.sn">{{scope.row.sn ? scope.row.sn : ''}}</div>
						<div class="">{{scope.row.code}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="優惠類別" class-name="type">
				</el-table-column>
				<el-table-column prop="amount" label="優惠額度" class-name="amount">
					<template slot-scope="scope">
						<div class="">{{scope.row.amount}}{{scope.row.type == '优惠折扣' ? '%' : '元'}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="goods_name" label="適用產品" class-name="goods_name">
				</el-table-column>
				<el-table-column prop="exp" label="有效期至" class-name="exp">
					<template slot-scope="scope">
						<div class="">{{scope.row.exp ? scope.row.exp : '--'}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="times" label="有效次數" class-name="times">
					<template slot-scope="scope">
						<div class="">{{scope.row.times == 0 ? '无限制' : scope.row.times}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="used" label="已用次數" class-name="used">
					<template slot-scope="scope">
						<div class="">{{scope.row.used}} <span class="user_btn" v-if="scope.row.used > 0"
								@click="handleToRecord(scope.row.id)">查看</span></div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="備註" class-name="remark">
					<template slot-scope="scope">
						<div class="" v-if="remarkId == scope.row.id">
							<el-input v-model="newRemark" placeholder="请输入备注"
								@keyup.enter.native="handleNewRemark(scope.row.id)" @blur="handleBlur"></el-input>
						</div>
						<div class="" v-else>{{scope.row.remark ? scope.row.remark : ''}} <i
								@click="handleRemarkId(scope.row.id)" class="el-icon-edit"></i></div>

					</template>
				</el-table-column>
				<el-table-column prop="status" label="狀態" class-name="status">
					<template slot-scope="scope">
						<el-switch @change="handleStatus(scope.row)" v-model="scope.row.status" active-value="1"
							inactive-value="2" active-color="#38E019" inactive-color="#FF5219">
						</el-switch>
						<!-- <div class="">{{scope.row.status == 1 ? '启用' : '禁用'}}</div> -->
					</template>
				</el-table-column>
				<el-table-column prop="updated_at" label="操作日期" class-name="updated_at">
					<template slot-scope="scope">
						<div class="">{{scope.row.updated_at ? scope.row.updated_at : '--'}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column
			    	class-name="oper"
			    	prop="oper"
			    	label="操作"
					width="60"
			    >
			    	<template slot-scope="scope">
			    		<i @click="handleDel(scope.row.id)" class="el-icon-delete"></i>
			    	</template>
			    </el-table-column> -->
			</el-table>

			<el-row :gutter="20" v-show="downFile">
				<el-col :span="12">
					
					<form :action="http" method="post" autocomplete="off" v-show="false">
						<input type="text" name="sn1" :value="formData3.sn1">
						<input type="text" name="sn2" :value="formData3.sn2">
						<input type="text" name="act" :value="formData3.act">
						<button type="submit" ref="down">下載成excel文件</button>
					</form>
				</el-col>
			</el-row>


				<!-- 分页 -->
				<el-pagination
				prev-text="上一頁"
				next-text="下一頁" class="pagination qjc-texta-c" layout="total, prev, pager, next,jumper" hide-on-single-page
					:current-page.sync="pager.page" :page-count="pager.pagecount" :page-size="pager.pagesize"
					:total="pager.count" @current-change="pageChange">
				</el-pagination>

			<el-dialog :title="(oper == 'add'?'添加':(oper == 'edit'?'修改':'')) + '優惠碼'" :visible.sync="isAlert"
				width="50%">
				<el-form :model="formData" :rules="rules" ref="form">
					<el-form-item label="優惠碼" prop="code">
						<div class="code_cell">
							<el-input v-model="formData.code"
								onkeyup="this.value=this.value.replace(/[^\w_\d{0,8}]/g,'');" maxlength="8"
								placeholder="請輸入"></el-input>
							<div class="code_btn" @click="handleCode">隨機生成</div>
						</div>

					</el-form-item>

					<el-form-item label="類別" prop="type">
						<el-select v-model="formData.type" placeholder="請選擇">
							<el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="適用產品" prop="goods_ids">
						<el-checkbox-group v-model="formData.goods_ids" @change="handlePackage">
							<el-checkbox v-for="(item, index) in packageOptions" :key="item.value"
								:label="item.value">{{item.label}}(￥{{item.price}})</el-checkbox>
						</el-checkbox-group>

					</el-form-item>
					<el-form-item label="優惠額度" prop="amount">
						<div class="quota_cell">
							<el-input v-model="formData.amount" placeholder="請輸入" type="number"></el-input>
							<span class="unit">{{formData.type == '3' ? '%' : '元'}}</span>
						</div>
					</el-form-item>
					<el-form-item label="有效期至" prop="exp">
						<el-date-picker v-model="formData.exp" type="date" value-format="yyyy-MM-dd"
							:picker-options="pickerOptions" placeholder="選擇日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="有效次數" prop="times">
						<div class="times_cell">
							<el-input v-model="formData.times" placeholder="請輸入" type="number"
								:disabled="noTimes"></el-input>
							<el-checkbox :class="noTimes ? 'noTimes active' : 'noTimes'"
								v-model="noTimes">無限制</el-checkbox>
						</div>
					</el-form-item>
					<el-form-item label="是否啟用" prop="status">
						<el-switch v-model="formData.status" active-color="#38E019" inactive-color="#FF5219">
						</el-switch>
					</el-form-item>
					<el-form-item label="備註" prop="remark">
						<el-input v-model="formData.remark" placeholder="請輸入"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button class="cancel-btn" @click="formCancel">取消</el-button>
					<el-button class="submit-btn" @click="formSubmit">提交</el-button>
				</span>
			</el-dialog>

			<el-dialog title="批量生成優惠碼" :visible.sync="isAlert2" width="50%">
				<el-form :model="formData2" :rules="rules2" ref="form2">
					<el-form-item label="序列號規則" prop="sn">
						<div class="code_cell">
							<el-input v-model="formData2.sn" type="number" placeholder="請輸入"></el-input>
						</div>

					</el-form-item>
					<el-form-item label="添加個數" prop="num">
						<div class="code_cell">
							<el-input v-model="formData2.num" type="number" placeholder="請輸入"></el-input>
						</div>

					</el-form-item>
					<el-form-item label="類別" prop="type">
						<el-select v-model="formData2.type" placeholder="請選擇">
							<el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="適用產品" prop="goods_ids">
						<el-checkbox-group v-model="formData2.goods_ids" @change="handlePackage">
							<el-checkbox v-for="(item, index) in packageOptions" :key="item.value"
								:label="item.value">{{item.label}}(￥{{item.price}})</el-checkbox>
						</el-checkbox-group>

					</el-form-item>
					<el-form-item label="優惠額度" prop="amount">
						<div class="quota_cell">
							<el-input v-model="formData2.amount" placeholder="請輸入" type="number"></el-input>
							<span class="unit">{{formData2.type == '3' ? '%' : '元'}}</span>
						</div>
					</el-form-item>
					<el-form-item label="有效期至" prop="exp">
						<el-date-picker v-model="formData2.exp" type="date" value-format="yyyy-MM-dd"
							:picker-options="pickerOptions" placeholder="選擇日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="有效次數" prop="times">
						<div class="times_cell">
							<el-input v-model="formData2.times" placeholder="請輸入" type="number"
								:disabled="noTimes"></el-input>
							<el-checkbox :class="noTimes ? 'noTimes active' : 'noTimes'"
								v-model="noTimes">無限制</el-checkbox>
						</div>
					</el-form-item>
					<el-form-item label="是否啟用" prop="status">
						<el-switch v-model="formData2.status" active-color="#38E019" inactive-color="#FF5219">
						</el-switch>
					</el-form-item>
					<el-form-item label="備註" prop="remark">
						<el-input v-model="formData2.remark" placeholder="請輸入"></el-input>
					</el-form-item>
				</el-form>

				<span slot="footer">
					<div class="dialog-footer">
						<el-button class="cancel-btn" @click="formCancel">取消</el-button>
						<el-button class="submit-btn" @click="formSubmit2">提交</el-button>
					</div>

					<p class="tips_p">序列號規則: 一共12位</p>
					<p class="tips_p">序列號規則從100020010001開始，個數為20個，則生成序列號依次為100020010001、100020010002...100020010020</p>
					<p class="tips_p">首四位按批次從1000開始順序加一，例如第一批為1000，第二批為1001</p>
					<p class="tips_p">中間四位為（地區碼，0，產品編號），大陸地區碼為1，香港為2，例如大陸AI智慧健康為1001，大陸尊貴白金為1002，香港AI智慧健康為2001</p>
					<p class="tips_p">最後四位為卡編號，順序編碼</p>
				</span>
			</el-dialog>

			<el-dialog title="批量生成優惠碼" :visible.sync="isAlert3" width="50%">
				<el-form :model="formData3" :rules="rules3" ref="form3">
					<el-form-item label="序列號開始" prop="sn1">
						<div class="code_cell">
							<el-input v-model="formData3.sn1" type="number" placeholder="請輸入"></el-input>
						</div>

					</el-form-item>
					<el-form-item label="序列號結束" prop="sn2">
						<div class="code_cell">
							<el-input v-model="formData3.sn2" type="number" placeholder="請輸入"></el-input>
						</div>
					</el-form-item>
				</el-form>
				<span slot="footer">
					<div class="dialog-footer">
						<el-button class="cancel-btn" @click="formCancel2">取消</el-button>
						<el-button class="submit-btn" @click="formSubmit3">下載</el-button>
					</div>
				</span>
			</el-dialog>
			<el-dialog title="优惠码使用记录" :visible.sync="isUsedShow" width="60%" class="used_dialog">
				<el-table :data="usedList" style="width: 100%">
					<template slot="empty">
						<div class="empty-wrap">
							<el-image class="empty-img" :src="require('@/assets/images/empty-download.png')"></el-image>
							<div class="empty-text">暂无数据</div>
						</div>
					</template>
					<el-table-column label="编号" prop="id" width="80"></el-table-column>
					<el-table-column label="优惠码" prop="code"></el-table-column>
					<el-table-column label="手机号" prop="mobile"></el-table-column>
					<el-table-column label="使用时间" prop="created_at"></el-table-column>
					<el-table-column label="订单编号" prop="order_no"></el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination
				prev-text="上一頁"
				next-text="下一頁" @current-change="pageChange2" :current-page.sync="pager2.page" hide-on-single-page
					:page-size="pager2.pagesize" layout="total, prev, pager, next" :total="pager2.count">
				</el-pagination>
			</el-dialog>
			<!-- <Alertb :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog" @on-confirm="confirmDialog" /> -->

			<!-- <iframe id="iframe" class="qjc-wid-100 qjc-hei-100" :src="iframeUrl" frameborder="0"></iframe> -->
			<Alert :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog"
				@on-confirm="confirmDialog" />
		</div>
	</div>
</template>

<script>
	import discount from '../assets/js/discount'

	import Alert from '../components/alert'
	export default {
		components: {
			Alert
		},
		name: "discount",
		...discount
	}
</script>

<style scoped>
	.stepTit {
		/* margin-bottom: 0.2rem; */
		text-align: left;
		font-size: 0.16rem;
		font-family: PingFangTC-Medium, PingFangTC;
		font-weight: 500;
		color: rgba(64, 68, 77, 1);
		line-height: 0.16rem;
	}

	.search_title {
		display: flex;
		align-items: center;
		font-size: 16px;
		font-family: PingFangTC-Light, PingFangTC;
		font-weight: 300;
		color: rgba(64, 68, 77, 1);
	}

	.right-wrap {
		font-size: 16px;
		font-family: "PingFang SC", "Helvetica Neue", Helvetica, Arial, "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
		color: #777F8F;
		background-color: #fff;
	}



	.search>>>.el-input-group__prepend {
		width: 112px;
	}

	.search>>>.el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		/* padding: 10px 12px; */
		background-color: transparent;
		margin-right: 0.3rem;
	}

	.search>>>.el-select .el-input__inner {
		text-align: center;
		padding-right: 25px;
	}

	.search>>>.el-select .el-input__suffix {
		right: 0;
	}

	.search>>>.el-select .el-icon-arrow-up {
		line-height: 1;
	}

	.search>>>.el-range-editor .el-range-input {
		background-color: transparent;
	}

	.list>>>.el-table__body,
	.list>>>.el-table__footer,
	.list>>>.el-table__header {
		table-layout: auto;
	}

	.list>>>table {
		/* width: 10.92px; */
	}

	.list.el-table--striped>>>.el-table__body tr.el-table__row--striped td,
	.list>>>thead th {
		background: #FAFBFC;
	}

	.list>>>.cell {
		/* padding-left: 24px; */
		padding-right: 0;
	}

	.list>>>thead th {
		/* display: inline-block; */
		color: #40444D;
		font-size: 14px;
		font-weight: 500;
		text-align: left;
		border-bottom: none;
	}

	.list>>>td {
		color: #777F8F;
		font-size: 14px;
		/* display: inline-block; */
		border-bottom: none;
	}

	.list>>>.package .cell {
		width: 200px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	

	.list>>>.el-button:active {
		background-color: transparent !important;
		color: #5B73DC;
	}

	.add {
		padding: 8px 12px;
		margin: 24px 0 12px;
		color: #fff;
	}

	.used_dialog>>>.el-dialog__body {
		padding: 0 20px 30px;
	}

	::v-deep input::-webkit-outer-spin-button,
	::v-deep input::-webkit-inner-spin-button {
		-webkit-appearance: none !important;
	}

	::v-deep input[type='number'] {
		line-height: 1;
		-moz-appearance: textfield !important;
	}

	.empty-wrap {
		padding: 100px 0;
	}

	.empty-img {
		width: 338px;
		height: 218px;
	}

	.el-dialog .el-form .el-form-item>>>.code_cell .el-input__inner {
		padding-right: 80px !important;
	}

	.el-dialog .el-form .el-form-item>>>.el-date-editor.el-input,
	.el-dialog .el-form .el-form-item>>>.el-date-editor.el-input__inner {
		width: 100%;
	}

	.el-dialog .el-form .el-form-item>>>.el-select {
		width: 100%;
	}

	.el-dialog .el-form>>>.el-form-item {
		margin-bottom: 8px;
	}

	.el-dialog .el-form>>>.el-form-item__label {
		width: 16%;
		padding-right: 24px;
		margin-left: 4%;
		text-align: right;
	}

	.el-dialog .el-form>>>.el-form-item__content {
		float: left;
		width: 60%;
		margin-right: 0;
	}
</style>
<style lang="scss" scoped>
	.print {
		display: flex;
		width: 100%;
		height: 100%;

		.el-button.qjc-fts-16 {
			font-size: 15px;
		}

		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 0 24px 30px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			overflow-y: auto;

			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;

				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;

					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}

				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}

			.left-list {
				padding-top: 20px;
			}

			.left-enp-item {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				cursor: pointer;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;

				&:hover {
					color: #7A92FB;
				}
			}

			.left-enp-item-active {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				cursor: pointer;
			}

			.enp-item-status {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FF5219;
				background-color: #FDE8E2;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}

			.enp-item-name {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.enp-item-status-active {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #6883FB;
				background-color: #DCE3FF;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
		}

		.right-wrap {
			position: relative;
			flex: 1;
			padding: 10px 20px;
			overflow: auto;

			.query-wrap {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 16px;

				.query-package {
					width: 226px;
				}
			}

			.c-danger {
				color: #FF4C52;
			}

			.query-date {
				display: flex;
				align-items: center;
				margin-left: 32px;

				.query-date-label {
					margin-right: 10px;
				}
			}

			.query-btn {
				width: 96px;
				height: 34px;
				background: #6883FB;
				border-radius: 17px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				border: none;
			}

		}

		.search {
			display: flex;
			align-items: center;
			margin-bottom:10px ;
	
			.el-input {
				width: 226px;
			}

			.el-button {
				
			}

			.el-button:active {
				
			}
		}

		.list {
			margin-top: 16px;

			&::before {
				display: none;
			}

			.el-button {
				font-size: 14px;
				padding: 6px 8px;
				border: none;

				+.el-button {
					margin-left: 4px;
				}
			}
		}

		.pagination {
			flex: 1;
			padding-right: 24px;
			text-align: center;
			background-color: #fff;
			margin-top: 6px;
			display: flex;
			justify-content: flex-end;
		}
	}

	.el-select-dropdown__item.selected {
		color: #6681FA;
	}

	#iframe {
		height: 0;
	}

	.nextBtn {
		display: block;
		cursor: pointer;
		height: 34px;
		padding: 0 15px;
		background: rgb(102, 129, 250);
		border-radius: 2px;
		border: none;
		color: white;
		outline: none;
		font-size: 14px;
		// border-radius: 17px;
		margin-left: 30px;

	}

	.nextBtn2 {
		display: block;
		cursor: pointer;
		min-width: 1rem;
		padding: 0 0.15rem;
		height: 0.34rem;
		background: rgb(102, 129, 250);
		border-radius: 0.02rem;
		border: none;
		color: white;
		outline: none;
		font-size: 0.14rem;
		margin-top: 0.3rem;
	}

	.no-print {
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, .5);
		font-size: 18px;

		div {
			width: 500px;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			border-radius: 8px;

			p {
				padding: 24px;
				border-bottom: 1px solid #ccc;
			}

			span {
				display: inline-block;
				padding: 12px 24px;
				cursor: pointer;
			}
		}
	}

	.empty-wrap {
		padding: 100px 0;
	}

	.empty-img {
		width: 222px;
		height: 206px;
	}

	.empty-text {
		text-align: center;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		line-height: 18px;
	}

	.footer-wrap {
		// padding-top: 20px;
		display: flex;
		min-width: 1000px;
		max-width: 100%;
		width: 100%;
		height: 80px;
		background-color: #fff;
	}

	.btn-text {
		font-weight: 400;
		font-family: PingFangSC-Regular, PingFang SC;
	}

	.code_cell {
		position: relative;
		display: flex;
		align-items: center;

		input {
			padding-right: 80px;
		}

		.code_btn {
			position: absolute;
			top: 0;
			right: 20px;
			font-size: 14px;
			font-family: PingFang SC-Light, PingFang SC;
			font-weight: 300;
			color: #6883FB;
			cursor: pointer;
			z-index: 99;
		}
	}

	.el-icon-edit {
		color: #6681FA;
	}

	.user_btn {
		color: #6681FA;
		cursor: pointer;
	}

	.el-pagination {
		text-align: center;
	}

	.quota_cell {
		position: relative;
		display: flex;
		align-items: center;

		.unit {
			position: absolute;
			right: 10px;
			top: 0px;
		}
	}

	.times_cell {
		display: flex;
		align-items: center;

		.noTimes {
			height: 40px;
			padding: 0 12px;
			margin-left: 10px;
			border: 1px solid #DCDFE6;
			border-radius: 4px;
		}

		.active {
			border: 1px solid #6681FA;
		}
	}

	.el-dialog {

		.dialog-title {
			font-size: 18px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			text-align: center;
		}

		.all-power {
			-webkit-appearance: none;
			background-color: #FFF;
			background-image: none;
			border-radius: 4px;
			border: 1px solid #DCDFE6;
			box-sizing: border-box;
			color: #606266;
			display: inline-block;
			font-size: inherit;
			height: 40px;
			line-height: 40px;
			outline: 0;
			padding: 0 15px;
			transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
			width: 100%;
		}

		.dialog-footer {
			display: flex;
			align-items: center;
			justify-content: center;

			.cancel-btn {
				width: 94px;
				height: 34px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				border: 1px solid #6883FB;
				border-radius: 17px;
				background-color: #fff;
			}

			.submit-btn {
				width: 94px;
				height: 34px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #fff;
				border: none;
				border-radius: 17px;
				background-color: #6883FB;
				margin-left: 16px;
			}

			.el-button {
				padding: 9px 15px;
			}
		}
	}

	.tips_p {
		font-size: 14px;
		padding: 0 78px;
		margin-bottom: 10px;
		text-align: left;

	}
</style>